import clsx from 'clsx';

import * as styles from './journey-progress.css';

export type JourneyProgressState =
  | 'pending'
  | 'current'
  | 'completed'
  | 'problem';

export interface JourneyProgressStep {
  ariaLabel?: string;
  dataState?: string;
  id: string;
  label: string;
  state: JourneyProgressState;
  testId?: string;
}

export const JourneyProgress = ({
  ariaLabel,
  steps,
}: {
  ariaLabel: string;
  steps: readonly JourneyProgressStep[];
}) => {
  if (steps.length <= 1) return null;

  return (
    <div className={styles.overview} data-testid="journey-progress">
      <ol className={styles.stages} aria-label={ariaLabel}>
        {steps.map((step, index) => (
          <li
            key={step.id}
            className={clsx(
              styles.stage,
              step.state === 'current' && styles.stageCurrent,
              step.state === 'completed' && styles.stageCompleted,
              step.state === 'problem' && styles.stageProblem
            )}
            aria-current={step.state === 'current' ? 'step' : undefined}
            aria-label={
              step.ariaLabel ?? `${index + 1}/${steps.length}: ${step.label}`
            }
            data-step-id={step.id}
            data-step-state={step.dataState ?? step.state}
            data-stage-id={step.id}
            data-stage-state={step.dataState}
            data-testid={step.testId}
          >
            <span className={styles.stageMarker} aria-hidden="true">
              {index + 1}
            </span>
          </li>
        ))}
      </ol>
    </div>
  );
};
